import { AgencyEditorMode } from '../model';

/** Whether the route search opens an editor page: create, or edit of a specific record. */
export function opensAgencyEditor(editor: AgencyEditorMode | undefined, id: string | undefined) {
  return editor === AgencyEditorMode.Create || (editor === AgencyEditorMode.Edit && Boolean(id));
}
